module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"instruction":"Memorer"},"en":{"instruction":"Memorize"}}')
  delete Component.options._Ctor
}
